import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import LeftSideBar from 'components/LeftSideBar';
import Navigation from 'components/Navigation';
import {toggleLeftSideMenu, getMenuOpenState} from 'ducks/page';

import './styles.css';

interface PageProps {
  activeTab: string;
  locationRef: string;
}

class Page extends React.Component<
  PageProps & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps
> {
  state = {
    menuOpened: this.props.menuOpenStateFromStore
  };

  toggleMenu = () => {
    const newState = !this.state.menuOpened;
    this.setState({menuOpened: newState}, () =>
      this.props.toggleLeftSideMenu({menuOpen: newState})
    );
  };

  render() {
    const {children, activeTab, locationRef} = this.props;

    // The key={locationRef} here is needed for the page content to rerender
    // when the location is changed from the dropdown
    return (
      <div key={locationRef} className="PageLayout">
        <Navigation
          className="PageLayout__navigation"
          locationRef={locationRef}
        />
        <LeftSideBar
          className={classNames('PageLayout__leftSidebar', {
            'PageLayout__leftSidebar--opened': this.state.menuOpened
          })}
          activeTab={activeTab}
          leftSideBarOpened={this.state.menuOpened}
          locationRef={locationRef}
          toggleLeftSideBar={this.toggleMenu}
        />
        <div
          className={classNames('PageLayout__content', {
            'PageLayout__content--wide': !this.state.menuOpened
          })}>
          {children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  menuOpenStateFromStore: getMenuOpenState(state)
});

const mapDispatchToProps = {
  toggleLeftSideMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
